import { memo } from 'react';
import WithDriverIconPopup from '../WithDriverIconPopup';
function DriverAtFuelingMarker({ backgroundColor, borderColor }) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_3950_618)">
        <path
          d="M28 12C28 5.37258 22.6274 0 16 0C9.37258 0 4 5.37258 4 12C4 18.6274 9.37258 24 16 24C22.6274 24 28 18.6274 28 12Z"
          fill={backgroundColor}
        />
        <path
          d="M16 1C22.07 1 27 5.93 27 12C27 18.07 22.07 23 16 23C9.93 23 5 18.07 5 12C5 5.93 9.93 1 16 1ZM16 0C9.37 0 4 5.37 4 12C4 18.63 9.37 24 16 24C22.63 24 28 18.63 28 12C28 5.37 22.63 0 16 0Z"
          fill={borderColor}
          fillOpacity="0.87"
        />
        <path
          d="M23.02 7.73H23.03L19.31 4L18.25 5.06L20.36 7.17C19.42 7.53 18.75 8.43 18.75 9.5C18.75 10.88 19.87 12 21.25 12C21.61 12 21.94 11.92 22.25 11.79V16C22.25 16.55 21.8 17 21.25 17C20.7 17 20.25 16.55 20.25 16V14.5C20.25 13.4 19.35 12.5 18.25 12.5H10.25V18.5H17.25V14H18.75V16C18.75 17.38 19.87 18.5 21.25 18.5C22.63 18.5 23.75 17.38 23.75 16V9.5C23.75 8.81 23.47 8.18 23.02 7.73ZM21.25 10.5C20.7 10.5 20.25 10.05 20.25 9.5C20.25 8.95 20.7 8.5 21.25 8.5C21.8 8.5 22.25 8.95 22.25 9.5C22.25 10.05 21.8 10.5 21.25 10.5ZM17.25 6.5C17.25 5.4 16.35 4.5 15.25 4.5H12.25C11.15 4.5 10.25 5.4 10.25 6.5V10.5H17.25V6.5Z"
          fill={borderColor}
          fillOpacity="0.87"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3950_618"
          x="0"
          y="0"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity ="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3950_618" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3950_618"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default WithDriverIconPopup(memo(DriverAtFuelingMarker));
